import { c as _c } from "react/compiler-runtime";
import { CalendarWithCheckIcon, GoogleMeetIcon, LinkIcon, PersonalLocationIcon, PhoneIcon, ZoomLocationIcon, WalletIcon } from '@systemeio/ui/icons';
import { DangerButton, Modal, PrimaryButton } from '@systemeio/ui';
import { RescheduleBookingModal } from 'modules/calendar/bookings/components/reshedule-booking-modal';
import { BookingStatusEnum } from 'modules/calendar/bookings/constants';
import { useBookingDetails } from 'modules/calendar/bookings/hooks/use-booking-details';
import { BookingDetailsInterface } from 'modules/calendar/bookings/types/booking-details-interface';
import { BookingViewInterface } from 'modules/calendar/bookings/types/bookings-interface';
import { EventLocationTypeEnum } from 'modules/calendar/events/constants';
import { EventTypeEnum } from 'modules/calendar/events/enums/event-type-enum';
import ClockIcon from 'modules/funnels/funnel/icons/clock-icon';
import React, { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { FieldLabel } from 'shared/components/form/field-label';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { Loader } from 'shared/components/loader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { timeFormat } from 'shared/utils/date-time-format';
import { BookingQuestions } from './booking-questions';
import { BookingPaymentStatusLink } from './booking-status';
interface BookingDetailsModalProps {
  opened: boolean;
  onClose: () => void;
  booking: BookingViewInterface;
  onRescheduleBooking: (date: string, booking?: BookingViewInterface) => Promise<void>;
  onCancelBooking: (booking: BookingViewInterface) => Promise<void>;
}
export const BookingDetailsModal = t0 => {
  const $ = _c(44);
  const {
    booking,
    onClose,
    opened,
    onRescheduleBooking,
    onCancelBooking
  } = t0;
  const {
    t,
    tICU
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  let t1;
  if ($[0] !== booking.id || $[1] !== opened) {
    t1 = {
      bookingId: booking.id,
      opened
    };
    $[0] = booking.id;
    $[1] = opened;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    bookingDetails,
    bookingDetailsMutate
  } = useBookingDetails(t1);
  const [openedRescheduleBookingModal, setOpenedRescheduleBookingModal] = useState(false);
  const [openedCancelBookingModal, setOpenedCancelBookingModal] = useState(false);
  const freeSlots = booking.maxParticipants ? Math.max(0, booking.maxParticipants - booking.bookedSlots) : 0;
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.calendar.bookings.booking_details.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== booking.date || $[6] !== booking.eventId || $[7] !== booking.eventType || $[8] !== booking.status || $[9] !== bookingDetails || $[10] !== bookingDetailsMutate || $[11] !== freeSlots || $[12] !== opened || $[13] !== t || $[14] !== tICU || $[15] !== user?.timeFormat) {
    t3 = <>{bookingDetails ? <div><div className="flex flex-col gap-4"><FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={t("dashboard.calendar.bookings.booking_details.event_name")} labelRightElement={bookingDetails.eventName} labelClassName="text-base text-text-primary" /><FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={t("dashboard.calendar.bookings.booking_details.event_time")} labelRightElement={<div className="flex gap-1"><CalendarWithCheckIcon className="fill-brand-primary h-4 w-4" /><span>{timeFormat(booking.date, {
                timeFormat: user?.timeFormat
              })}</span></div>} labelClassName="text-base text-text-primary" /><FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={t("dashboard.calendar.bookings.booking_details.event_duration")} labelRightElement={<div className="flex gap-1"><ClockIcon className="h-4 w-4" active={true} /><span>{tICU("global.name_of_times.minute_icu", {
                minutes: bookingDetails.eventDuration
              })}</span></div>} labelClassName="text-base text-text-primary" /><FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={t("dashboard.calendar.bookings.booking_details.event_location")} labelRightElement={<FieldLocation bookingDetails={bookingDetails} />} labelClassName="text-base text-text-primary" />{booking.eventType === EventTypeEnum.Group ? <FieldLabel wrapperProps={{
            className: "flex-col gap-3"
          }} label={tICU("dashboard.calendar.bookings.booking_details.invitees_slot", {
            slotsLeft: freeSlots
          })} labelClassName="text-base text-text-primary" /> : <><FieldLabel wrapperProps={{
              className: "flex-col gap-3"
            }} label={t("dashboard.calendar.bookings.payment_title")} labelRightElement={<div className="flex gap-1"><WalletIcon className="fill-brand-primary h-4 w-4" /><BookingPaymentStatusLink booking={bookingDetails.bookings[0]} /></div>} labelClassName="text-base text-text-primary" /><FieldLabel wrapperProps={{
              className: "flex-col gap-3"
            }} label={t("dashboard.calendar.bookings.booking_details.invitee_name")} labelRightElement={<>{bookingDetails.bookings[0].contactId ? <LinkWithoutPrefetch className="primary-link" href={`/contacts/${bookingDetails.bookings[0].contactId}`} rel="noreferrer" target="_blank">{bookingDetails.bookings[0].inviteeName}</LinkWithoutPrefetch> : <span>{bookingDetails.bookings[0].inviteeName}</span>}</>} labelClassName="text-base text-text-primary" /></>}<div className="customScroll max-h-[280px] min-h-[180px] overflow-y-auto overflow-x-hidden">{bookingDetails.bookings.sort(_temp).map(bookings => <BookingQuestions key={`question-${bookings.inviteeName}-${bookings.bookingId}`} booking={bookings} bookingDetails={bookingDetails} bookingDetailsMutate={bookingDetailsMutate} eventType={booking.eventType} opened={opened} />)}</div></div><div className="mt-7 flex justify-end gap-4">{booking.eventId !== null && ![BookingStatusEnum.Cancelled, BookingStatusEnum.Past].includes(booking.status) && <DangerButton onClick={() => setOpenedCancelBookingModal(true)} width="large">{t("dashboard.bookings.actions.cancel_booking")}</DangerButton>}{bookingDetails.status !== BookingStatusEnum.Cancelled && <PrimaryButton onClick={() => setOpenedRescheduleBookingModal(true)} width="large">{t("dashboard.bookings.actions.reschedule_booking")}</PrimaryButton>}</div></div> : <div className="flex justify-center"><Loader /></div>}</>;
    $[5] = booking.date;
    $[6] = booking.eventId;
    $[7] = booking.eventType;
    $[8] = booking.status;
    $[9] = bookingDetails;
    $[10] = bookingDetailsMutate;
    $[11] = freeSlots;
    $[12] = opened;
    $[13] = t;
    $[14] = tICU;
    $[15] = user?.timeFormat;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== onClose || $[18] !== opened || $[19] !== t2 || $[20] !== t3) {
    t4 = <Modal opened={opened} onClose={onClose} title={t2}>{t3}</Modal>;
    $[17] = onClose;
    $[18] = opened;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== t) {
    t5 = t("dashboard.bookings.actions.cancel_booking_success");
    $[22] = t;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== t) {
    t6 = t("dashboard.calendar.bookings.actions.cancel_booking_confirm");
    $[24] = t;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpenedCancelBookingModal(false);
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== booking || $[28] !== onCancelBooking) {
    t8 = () => onCancelBooking(booking);
    $[27] = booking;
    $[28] = onCancelBooking;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== openedCancelBookingModal || $[31] !== t5 || $[32] !== t6 || $[33] !== t8) {
    t9 = <ConfirmationModal toastCaption={t5} confirmationText={t6} opened={openedCancelBookingModal} onClose={t7} onConfirm={t8} />;
    $[30] = openedCancelBookingModal;
    $[31] = t5;
    $[32] = t6;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setOpenedRescheduleBookingModal(false);
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== booking || $[37] !== onRescheduleBooking || $[38] !== openedRescheduleBookingModal) {
    t11 = <RescheduleBookingModal opened={openedRescheduleBookingModal} onClose={t10} booking={booking} onRescheduleBooking={onRescheduleBooking} eventType={booking.eventType} bookingId={booking.id} />;
    $[36] = booking;
    $[37] = onRescheduleBooking;
    $[38] = openedRescheduleBookingModal;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== t11 || $[41] !== t4 || $[42] !== t9) {
    t12 = <>{t4}{t9}{t11}</>;
    $[40] = t11;
    $[41] = t4;
    $[42] = t9;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  return t12;
};
type FieldLocationProps = {
  bookingDetails: BookingDetailsInterface;
};
const FieldLocation = t0 => {
  const $ = _c(28);
  const {
    bookingDetails
  } = t0;
  const {
    t
  } = useLocoTranslation();
  switch (bookingDetails.locationType) {
    case EventLocationTypeEnum.Phone:
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <PhoneIcon className="fill-brand-primary h-4 w-4" />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        const t2 = `tel:${bookingDetails.phone}`;
        let t3;
        if ($[1] !== bookingDetails.phone || $[2] !== t2) {
          t3 = <div className="flex items-center gap-1">{t1}<a className="primary-link" href={t2} type="phone">{bookingDetails.phone}</a></div>;
          $[1] = bookingDetails.phone;
          $[2] = t2;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        return t3;
      }
    case EventLocationTypeEnum.ExternalLink:
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <LinkIcon className="fill-brand-primary h-4 w-4" />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        let t2;
        if ($[5] !== bookingDetails.location) {
          t2 = <div className="flex items-center gap-1">{t1}{" "}<a className="primary-link" href={bookingDetails.location} rel="noreferrer" target="_blank">{bookingDetails.location}</a></div>;
          $[5] = bookingDetails.location;
          $[6] = t2;
        } else {
          t2 = $[6];
        }
        return t2;
      }
    case EventLocationTypeEnum.Zoom:
      {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <ZoomLocationIcon className="fill-brand-primary h-4 w-4" />;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        let t2;
        if ($[8] !== bookingDetails.location) {
          t2 = <div className="flex items-center gap-1">{t1}<a className="primary-link" href={bookingDetails.location} rel="noreferrer" target="_blank">{bookingDetails.location}</a></div>;
          $[8] = bookingDetails.location;
          $[9] = t2;
        } else {
          t2 = $[9];
        }
        return t2;
      }
    case EventLocationTypeEnum.GoogleMeet:
      {
        let t1;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <GoogleMeetIcon className="h-4 w-4" />;
          $[10] = t1;
        } else {
          t1 = $[10];
        }
        let t2;
        if ($[11] !== bookingDetails.location) {
          t2 = <div className="flex items-center gap-1">{t1}<a className="primary-link" href={bookingDetails.location} rel="noreferrer" target="_blank">{bookingDetails.location}</a></div>;
          $[11] = bookingDetails.location;
          $[12] = t2;
        } else {
          t2 = $[12];
        }
        return t2;
      }
    case EventLocationTypeEnum.Personal:
      {
        let t1;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <PersonalLocationIcon className="fill-brand-primary h-4 w-4" />;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        let t2;
        if ($[14] !== t) {
          t2 = t("dashboard.calendar.event_location_address");
          $[14] = t;
          $[15] = t2;
        } else {
          t2 = $[15];
        }
        let t3;
        if ($[16] !== bookingDetails.location || $[17] !== t2) {
          t3 = <span>{t2}: {bookingDetails.location}</span>;
          $[16] = bookingDetails.location;
          $[17] = t2;
          $[18] = t3;
        } else {
          t3 = $[18];
        }
        let t4;
        if ($[19] !== bookingDetails.phone || $[20] !== t) {
          t4 = bookingDetails.phone && <div className="flex gap-1"><span>{t("dashboard.calendar.event_location.phone")}: </span><a className="primary-link" href={`tel:${bookingDetails.phone}`} type="phone">{bookingDetails.phone}</a></div>;
          $[19] = bookingDetails.phone;
          $[20] = t;
          $[21] = t4;
        } else {
          t4 = $[21];
        }
        let t5;
        if ($[22] !== t3 || $[23] !== t4) {
          t5 = <div className="flex gap-1">{t1}<div className="flex flex-col gap-1">{t3}{t4}</div></div>;
          $[22] = t3;
          $[23] = t4;
          $[24] = t5;
        } else {
          t5 = $[24];
        }
        return t5;
      }
    default:
      {
        let t1;
        if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <LinkIcon className="fill-brand-primary h-4 w-4" />;
          $[25] = t1;
        } else {
          t1 = $[25];
        }
        let t2;
        if ($[26] !== bookingDetails.location) {
          t2 = <div className="flex items-center gap-1">{t1}<a className="primary-link" href={bookingDetails.location} rel="noreferrer" target="_blank">{bookingDetails.location}</a></div>;
          $[26] = bookingDetails.location;
          $[27] = t2;
        } else {
          t2 = $[27];
        }
        return t2;
      }
  }
};
function _temp(a, b) {
  return Number(a.status === BookingStatusEnum.Cancelled) - Number(b.status === BookingStatusEnum.Cancelled);
}